import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  patientId: yup.number().required(),
  pmId: yup.mixed().required(),
});

export const useSetPrimaryPaymentMethodMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (dto) => {
      const req = requestSchema.validateSync(dto, { string: true });
      return http.patch(
        HTTP_ENDPOINTS.patient.setPrimaryPaymentMethod({
          patientId: req.patientId,
          pmId: req.pmId,
        }),
      );
    },
    ...options,
    onSuccess: (...args) => {
      [
        QUERY_KEYS.client,
        QUERY_KEYS.clientCreditCards,
        QUERY_KEYS.stripe.paymentMethods,
      ].forEach((key) => {
        queryClient.invalidateQueries({
          queryKey: [key],
        });
      });
      options?.onSuccess?.(...args);
    },
  });
};
